var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      ref: "form",
      attrs: { method: "POST", action: _vm.action, target: "_blank" },
    },
    _vm._l(_vm.fields, function (field) {
      return _c("input", {
        key: field.name,
        attrs: { type: "hidden", name: field.name },
        domProps: { value: field.value },
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }